import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="21" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.004 7.5h-3.37v-5H7.581v5H4.21l5.896 5.833L16.005 7.5zM9.265 9.167v-5h1.685v5h.985l-1.828 1.808L8.28 9.167h.985zM4.211 15h11.793v1.667H4.21V15z" fill="#4285F4" /></svg>);